const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const OfficeModal = require("./OfficeModal");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const AT = require("../../core/vault/ActionTypes");
const Checkbox = require("../../core/view/Checkbox");
const CopyTable = require("../data/CopyTable");

const styles = require("./styles/CancelBundleModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "CancelBundleModal",

		propTypes: {
			// Injected by HOCs
			dispatch: PT.func.isRequired,

			data: PT.object.isRequired, //individual student data
			hasPendingBookDeferral: PT.bool,
			onClose: PT.func,
			status: PT.string, // "pending" or an error code
		},

		getInitialState: function() {
			return {
				cancelBooks: false,
				cancelYearly: false,
			};
		},

		cancelSubscription: function() {
			if (this.props.onClose) {
				this.props.onClose();
			}
			this.props.dispatch({
				type: AT.FINISH_SUBSCRIPTION_CANCEL_REQUEST,
				studentID: this.props.data.userID,
				refundBooks: this.state.cancelBooks,
				refundOnline: this.state.cancelYearly,
			});
		},

		toggleBooks: function() {
			const currentBooksState = this.state.cancelBooks;
			this.setState({
				cancelBooks: !currentBooksState,
			});
		},
		toggleYearly: function() {
			const currentYearlyState = this.state.cancelYearly;
			this.setState({
				cancelYearly: !currentYearlyState,
			});
		},

		render: function() {
			const {data, onClose} = this.props;
			const {cancelBooks, cancelYearly} = this.state;
			const buttonText =
				cancelBooks || cancelYearly ? "*Process Refund" : "Process Refund";
			const buttonClass =
				cancelBooks || cancelYearly ? styles.redButton : styles.disabledButton;
			const refundButton = (
				<div className={buttonClass} onClick={this.cancelSubscription}>
					{buttonText}
				</div>
			);

			const keepButton = (
				<div className={styles.button} onClick={onClose}>
					{"Keep Bundle"}
				</div>
			);

			const copy = CopyTable.getBundleCancelCopy(
				styles,
				data,
				cancelBooks,
				cancelYearly,
				Boolean(this.props.hasPendingBookDeferral)
			);

			return (
				<OfficeModal
					onClose={onClose}
					closeOnEsc={true}
					portalContainer={null}
					level="overBar"
					modalClass={styles.main}
				>
					<div className={styles.container}>
						<div className={styles.title}>{copy.title}</div>
						<div className={styles.text}>{copy.message}</div>
						<div className={styles.checkOuter}>
							<Checkbox
								className={styles.checkbox}
								text={"Books"}
								textClass={styles.checkboxText}
								isSelected={cancelBooks}
								tabIndex={1}
								onClick={this.toggleBooks}
							/>
							<Checkbox
								className={styles.checkbox}
								text={"Yearly Subscription"}
								textClass={styles.checkboxText}
								isSelected={cancelYearly}
								tabIndex={1}
								onClick={this.toggleYearly}
							/>
						</div>
						<div className={styles.reminder}>{copy.reminder}</div>
						<div className={styles.buttons}>
							{refundButton}
							{keepButton}
						</div>
					</div>
				</OfficeModal>
			);
		},
	})
);
